import { DeclarationHighValueGroupType } from '@e-origin/shared';

import { Variant } from '../types';

const H2 = DeclarationHighValueGroupType.H2;

export const nlExport: Variant = {
  // Only `section`/`code` move - base's own `rules: [B2B_NOT_H2]` already governs presence (B2B,
  // not H2) for every context; repeating a `{txClass: B2B}`-only rule here would drop the H2 exclusion.
  'valuationInformationTaxes.deliveryTerms.incotermCode': { section: 'customs' },
  'valuationInformationTaxes.deliveryTerms.location': { section: 'customs' },
  'valuationInformationTaxes.deliveryTerms.country': { section: 'customs', code: 'CL008' },

  'consignment.countryOfExport': { rules: [{ when: { txClass: ['B2B'] }, then: { present: true } }] },
  'consignment.carrier': { rules: [{ when: { txClass: ['B2B'] }, then: { present: true } }] },
  'consignment.countryOfDestination': { code: 'CL008' },

  'declarationGlobal.totalAmountInvoiced': { rules: [{ when: { group: H2 }, then: { present: false } }] },
  'goodShipmentGlobal.invoiceCurrency': { rules: [{ when: { group: H2 }, then: { present: false } }] },

  'messageInfo.security': { present: true, amendmentLocked: true },
  'consignment.customsOfficePresentation.referenceNumber': { amendmentLocked: true, code: 'CL193' },
  'consignment.customsOfficeExit.referenceNumber': { present: true },
  'consignment.customsOfficeExport.referenceNumber': { present: true },
  'consignment.customsSupervisingOffice.referenceNumber': { amendmentLocked: true },
  customer: { amendmentLocked: true },

  'transportInformation.departureTransportMeans.identificationNumber': { rules: [{ when: { txClass: ['B2B'] }, then: { present: true } }] },
  'transportInformation.departureTransportMeans.typeOfIdentification': { rules: [{ when: { txClass: ['B2B'] }, then: { present: true } }] },
  'transportInformation.departureTransportMeans.nationality': { rules: [{ when: { txClass: ['B2B'] }, then: { present: true } }] },
  'transportInformation.activeBorderTransportMeans.identificationNumber': { present: true },
  'transportInformation.activeBorderTransportMeans.typeOfIdentification': { present: true },
  'transportInformation.countryOfRoutingOfConsignment': { present: true },
  'transportInformation.inlandModeOfTransport': { label: 'Departure transport means mode' },
};
